import { render, staticRenderFns } from "./IndividualContents.vue?vue&type=template&id=ec2c371c&"
import script from "./IndividualContents.vue?vue&type=script&lang=js&"
export * from "./IndividualContents.vue?vue&type=script&lang=js&"
import style0 from "./IndividualContents.vue?vue&type=style&index=0&id=ec2c371c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports